import { EventHubListener } from './forge-viewer.types';

export class EventHub {
    private listeners = new Map<string, Set<EventHubListener<any>>>();

    on<T extends any[]>(event: string, fn: EventHubListener<T>) {
        const set = this.listeners.get(event) ?? new Set();
        set.add(fn as EventHubListener);
        this.listeners.set(event, set);
    }

    off<T extends any[]>(event: string, fn?: EventHubListener<T>) {
        if (!fn) {
            this.listeners.delete(event);
            return;
        }
        const set = this.listeners.get(event);
        set?.delete(fn as EventHubListener);
    }

    emit<T extends any[]>(event: string, ...args: T) {
        const set = this.listeners.get(event);
        if (!set) return;
        for (const fn of Array.from(set)) {
            try {
                (fn as EventHubListener<T>)(...args);
            } catch (err) {
                console.error('Event handler error for', event, err);
            }
        }
    }
}
